module.exports = __webpack_public_path__ + "static/media/siebel2.5971b853.png";